import { ExibirClientesERastreaveis } from './exibirClientesERastreaveis';

const clientesRastreaveis = new ExibirClientesERastreaveis();
clientesRastreaveis.telaCriarCarregarRastreaveisDosClientesSelecionados();
clientesRastreaveis.telaCriarCarregarClientes();

clientesRastreaveis.telaAtualizarCarregarRastreaveis();
clientesRastreaveis.telaAtualizarCarregarClientes();
